const eWinAmountSizes = {
  H: {
    REGULAR: 208,
    SMALL: 150,
  },
  V: {
    REGULAR: 140,
    SMALL: 120,
  }
};

export {
  eWinAmountSizes,
}
